exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".end-main[data-v-d2515ae6]{margin:33% 20px 0;text-align:center}.bottom[data-v-d2515ae6]{margin:16px;position:absolute;right:10px;left:10px;bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d2515ae6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/end.vue
// module id = 405
// module chunks = 1